module.exports = __webpack_public_path__ + "static/media/signal-alt.84b4bf2e.svg";